/* Help Center — category switching, FAQ accordions, view-all toggle.
   Vanilla JS, no dependencies. */
(function () {
  var root = document.querySelector('.hc');
  if (!root) return;

  var tiles = Array.prototype.slice.call(root.querySelectorAll('.hc-cat[data-cat]'));
  var cats = Array.prototype.slice.call(root.querySelectorAll('.hc-faq__cat'));

  /* --- category tiles --- */
  tiles.forEach(function (tile) {
    var hit = tile.querySelector('.hc-cat__hit');
    if (!hit) return;
    var label = tile.querySelector('span:last-of-type');
    if (label) hit.setAttribute('aria-label', 'Show ' + label.textContent.trim() + ' questions');
    hit.addEventListener('click', function () {
      var key = tile.getAttribute('data-cat');
      tiles.forEach(function (t) {
        t.classList.toggle('is-active', t === tile);
        var b = t.querySelector('.hc-cat__hit');
        if (b) b.setAttribute('aria-pressed', t === tile ? 'true' : 'false');
      });
      cats.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-cat') === key);
      });
    });
  });

  /* --- question accordions ---
     The whole row head is the hit target, not just the + button: clicking the
     question itself is what people try first. The + stays the focusable,
     screen-reader-announced control, and the click it fires bubbles up into
     this same handler — so it must NOT keep a handler of its own, or the two
     would fire in turn and cancel each other out.
     One answer open at a time per category, so the list never grows past the
     Ask Shelly card beside it. */
  /* The answer panel animates max-height, and that height used to come from a
     fixed CSS value (12rem at desktop, 260px below 960). The answer is merchant
     rich text of any length, so anything longer than the cap was simply cut off
     mid-sentence with no way to read the rest. Measuring the content is the only
     value that is right for every answer. */
  function panelOf(row) {
    return row.querySelector('.hc-faq__a');
  }

  function setRow(row, open) {
    row.classList.toggle('is-open', open);
    var btn = row.querySelector('.hc-faq__plus');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');

    var a = panelOf(row);
    if (!a) return;

    if (open) {
      a.style.maxHeight = a.scrollHeight + 'px';
    } else {
      /* Closing from `none` (set once the open transition finished) has no
         concrete height to animate FROM, so the panel would vanish instantly.
         Put the measured height back, force a reflow so the browser accepts it
         as the starting value, then collapse. */
      if (a.style.maxHeight === 'none' || a.style.maxHeight === '') {
        a.style.maxHeight = a.scrollHeight + 'px';
      }
      void a.offsetHeight;
      a.style.maxHeight = '0px';
    }
  }

  /* Release the cap once the panel is fully open, so an answer that grows
     afterwards — a late web font, a slow image, a window resize reflowing the
     text to more lines — is never clipped by a height measured too early. */
  root.addEventListener('transitionend', function (e) {
    if (e.propertyName !== 'max-height') return;
    var a = e.target;
    if (!a.classList || !a.classList.contains('hc-faq__a')) return;
    var row = a.closest ? a.closest('.hc-faq__row') : null;
    if (row && row.classList.contains('is-open')) a.style.maxHeight = 'none';
  });

  /* Any row the template renders already open needs the same treatment; it has
     no inline height yet and would otherwise sit at the CSS fallback. */
  Array.prototype.forEach.call(root.querySelectorAll('.hc-faq__row.is-open'), function (row) {
    var a = panelOf(row);
    if (a) a.style.maxHeight = 'none';
  });

  root.addEventListener('click', function (e) {
    var head = e.target.closest ? e.target.closest('.hc-faq__row-head') : null;
    if (!head) return;
    var row = head.closest('.hc-faq__row');
    if (!row) return;
    var open = !row.classList.contains('is-open');
    var list = row.closest('.hc-faq__list') || root;
    Array.prototype.forEach.call(list.querySelectorAll('.hc-faq__row.is-open'), function (other) {
      if (other !== row) setRow(other, false);
    });
    setRow(row, open);
  });

  /* --- view all / show less --- */
  Array.prototype.forEach.call(root.querySelectorAll('.hc-faq__viewall'), function (btn) {
    btn.addEventListener('click', function () {
      var cat = btn.closest('.hc-faq__cat');
      if (!cat) return;
      var expanded = cat.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var span = btn.querySelector('span');
      if (span) span.textContent = expanded ? 'Show Less' : 'View All Questions';
    });
  });
})();
